import "./slide.scss";
const timespan = "0.3s";
export const slideup = (elements) => {
  if (!(elements instanceof Array)) elements = [elements];
  elements.forEach((e) => {
    if (e.style) {
      let h = e.clientHeight;
      e.style.maxHeight = `${h}px`;
      let transitions = e.style.transition.split(",");
      transitions = transitions.filter(
        (t) => t !== "" && !t.match(/max\-height/)
      );
      transitions.push(`max-height ${timespan}`);
      e.style.transition = transitions.join(", ");
      e.style.overflow = "hidden";
      setTimeout(() => {
        e.style.maxHeight = `0px`;
      }, 10);
    }
  });
};
export const slidedown = (elements) => {
  if (!(elements instanceof Array)) elements = [elements];
  elements.forEach((e) => {
    if (e.style) {
      if (e.style.display === "none") {
        e.style.maxHeight = `0px`;
        e.style.display = "";
      }
      let transitions = e.style.transition.split(",");
      transitions = transitions.filter((t) => !t.match(/max\-height/));
      transitions.push(`max-height ${timespan}`);
      e.style.transition = transitions.join(", ");
      e.style.overflow = "hidden";
      setTimeout(() => {
        e.style.maxHeight = `100vh`;
      }, 10);
    }
  });
};
